import {ChatSettingState, initialAppSetting} from "../types/chat-setting-types";
import {Reducer} from "redux";
import {ChatSettingActions} from "../actions/chat-setting-actions";
import {AppRootState} from "./root-reducer";
import {createSelector} from "reselect";


export  const chatSettingReducer:Reducer<ChatSettingState> =(state=initialAppSetting,action) =>{

    switch (action.type){
        case ChatSettingActions.APPLICATION_THEME_RESULT:
            return {
                ...state,
                themeInfo: action.payload
            }
        default:
            return state
    }

}



const appSettingTheme = (state: AppRootState) => state.chatSettingReducer.themeInfo;
export const getAppSettingTheme = createSelector([appSettingTheme], (data) => data);